// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:56:49

export default {
  "id": "colorsandforms",
  "slug": "colorsandforms",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7bd113a339b0492baac80d9416889c45-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7bd113a339b0492baac80d9416889c45/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Colors&Forms",
      "description": "Dynamic and exciting!\nChoose the game mode!\nComplete missions and pass all levels!\nLevels differ in color palettes and falling elements.\nInteract with the objects appearing on the game screen, which complicate the process of the game.\nAfter accumulating enough pieces, unlock the game type “Infinity”!\nChoose your favorite level and accumulate as many pieces as possible to beat your opponents!",
      "instructions": "The control is simple - move the pieces at the bottom of the tracks to match the falling elements and complete the missions on each level.\nBefore the game, choose the appropriate game mode by speed.\nBe careful, there may be objects on the screen that you need to interact with by clicking on them.\nTo switch the type of game, use the button with the image of a castle.\nChange the language, disable music and sound effects - in the game settings.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "arcade"
      ]
    },
    "zh-CN": {
      "title": "色彩与形态",
      "description": "动态且激动人心！\n选择游戏模式！\n完成任务，通过所有关卡！\n关卡在色彩搭配和下落元素上有所不同。\n与游戏屏幕上出现的物体互动，这些物体会复杂化游戏过程。\n累积足够多的碎片后，解锁“无限”游戏类型！\n选择你喜欢的关卡，尽可能多地累积碎片，打败你的对手！",
      "instructions": "控制简单 - 将轨道底部的部件移动以匹配下落的元素，并在每个关卡中完成任务。\n游戏前，根据速度选择合适的游戏模式。\n小心，屏幕上可能有需要通过点击与之交互的对象。\n使用带有城堡图像的按钮切换游戏类型。\n更改语言，禁用音乐和音效 - 在游戏设置中。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "街机"
      ]
    },
    "zh-TW": {
      "title": "顏色與形狀",
      "description": "動態且刺激！\n選擇遊戲模式！\n完成任務，通過所有關卡！\n關卡之間在色彩配置和下落元素上有所不同。\n與遊戲畫面出現的物體互動，複雜化遊戲過程。\n積累足夠的碎片後，解鎖遊戲類型“無限”！\n選擇你喜歡的關卡，積累盡可能多的碎片來擊敗對手！",
      "instructions": "控制簡單 - 將軌道底部的拼圖移動以匹配下落的元素，並完成每個關卡的任務。\n遊戲開始前，選擇合適的遊戲模式按速度。\n小心，畫面上可能會有需要點擊互動的物件。\n使用圖示為城堡的按鈕切換遊戲類型。\n更改語言、關閉音樂和音效 - 在遊戲設定中。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1玩家",
        "街機"
      ]
    },
    "zh-HK": {
      "title": "顏色與形狀",
      "description": "動態而刺激！\n選擇遊戲模式！\n完成任務，通過所有關卡！\n關卡在色彩調配和掉落元素上有所不同。\n與遊戲畫面上出現的物件互動，從而複雜化遊戲過程。\n累積足夠的碎片後，解鎖遊戲類型「無限」！\n選擇你喜愛的關卡，累積盡可能多的碎片以擊敗對手！",
      "instructions": "控制簡單 - 移動鐵軌底部的部件，與下墜的元素匹配，並完成每個關卡的任務。\n遊戲開始前，選擇合適的遊戲模式按速度。\n小心，螢幕上可能會有需要透過點擊進行互動的物體。\n要切換遊戲類型，使用印有城堡圖像的按鈕。\n更改語言，關閉音樂和音效 - 在遊戲設定中。",
      "genres": [
        "隨機"
      ],
      "tags": [
        "1玩家",
        "街機"
      ]
    },
    "ja": {
      "title": "色と形",
      "description": "ダイナミックで興奮する！\nゲームモードを選んでください！\nミッションを完了し、すべてのレベルをクリアしてください！\nレベルは色パレットや落下する要素で異なります。\nゲーム画面に現れるオブジェクトと対話し、ゲームの進行を複雑にするようにしてください。\n十分なピースを積み重ねると、「無限」ゲームモードを解禁します！\nお気に入りのレベルを選び、できるだけ多くのピースを積み重ねて、敵対者を破りましょう！",
      "instructions": "コントロールは簡単です - 軌道の下にあるピースを動かして降下する要素と一致させ、各レベルのミッションを完了します。\nゲーム前に、速度に応じたゲームモードを選んでください。\n気をつけて、スクリーン上にオブジェクトがあり、それらと対話するためにクリックする必要があるかもしれません。\nゲームの種類を切り替えるには、城の画像があるボタンを使用します。\n言語を変更し、音楽と効果音をオフにする - ゲーム設定で。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "アーケード"
      ]
    },
    "ko": {
      "title": "색상과 형태",
      "description": "다이나믹하고 흥미진진하다!\n게임 모드를 선택하세요!\nミッション을 완료하고 모든 레벨을 통과하세요!\n레벨들은 색상 팔레트와 떨어지는 요소로 다릅니다.\n게임 스크린에 나타나는 오브젝트와 상호작용하여 게임의 과정을 복잡하게 합니다.\n충분한 조각을 모으면 게임 타입 \"infinity\"을 해금하세요!\n좋아하는 레벨을 선택하고 가능한 많은 조각을 모아 상대를 이겨보세요!",
      "instructions": "컨트롤은 간단합니다 - 트랙 아래의 조각을 이동하여 떨어지는 요소와 일치시키고 각 레벨의 미션을 완료하세요.\n게임 전에 속도에 따라 적절한 게임 모드를 선택하세요.\n주의하세요, 화면에 객체가 있을 수 있으며 클릭하여 상호작용해야 할 수 있습니다.\n게임 타입을 변경하려면 성 이미지가 있는 버튼을 사용하세요.\n언어 변경, 음악 및 사운드 효과 비활성화 - 게임 설정에서.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "아케이드"
      ]
    },
    "fr": {
      "title": "Couleurs & Formes",
      "description": "Dynamique et passionnant !\nChoisissez le mode de jeu !\nTerminez les missions et passez tous les niveaux !\nLes niveaux diffèrent par leurs couleurs et leurs éléments tombants.\nInteragissez avec les objets apparaissant sur l'écran de jeu, qui compliquent le processus du jeu.\nAprès avoir accumulé suffisamment de pièces, débloquez le mode de jeu “Infinity” !\nChoisissez votre niveau préféré et accumulez le plus de pièces possible pour battre vos adversaires !",
      "instructions": "Le contrôle est simple - déplacez les pièces au bas des voies pour correspondre aux éléments tombants et accomplir les missions de chaque niveau.\nAvant le jeu, choisissez le mode de jeu approprié par rapport à la vitesse.\nFaites attention, il peut y avoir des objets sur l'écran avec lesquels vous devez interagir en cliquant dessus.\nPour changer le type de jeu, utilisez le bouton avec l'image d'un château.\nModifier la langue, désactiver la musique et les effets sonores - dans les réglages du jeu.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1 joueur",
        "arcade"
      ]
    }
  }
};
